/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useRef ,useEffect, useCallback} from 'react'; // Added useCallback
import {
  Table,
  Modal,
  ModalBody, ModalHeader,
  Input, Label, Button // Import Button here
} from 'reactstrap';
import * as moment from 'moment';
import * as collections from '../CreditProfile/collections/index.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import accountInfo from '../../../assets/images/accountInfo.png';
import address from '../../../assets/images/address.png';
import AccountSum from '../../../assets/images/AccountSummary.png';
import Enquiries from '../../../assets/images/Enquiries.png';
import employee from '../../../assets/images/employee.png';
import customerInfo from '../../../assets/images/customerInfo.png';
import mail from '../../../assets/images/mail.png';
import phone from '../../../assets/images/phone.png';
import monthwise from '../../../assets/images/monthwise.png';
import legend from '../../../assets/images/legend.png';
import slider from '../../../assets/images/slider.png';
import bankImg from '../../../assets/images/bankImg.png';
import axiosInstance from '../../../helpers/axios.js';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import {
  Chart as ChartJs, ArcElement, Tooltip, Legend, CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from 'chart.js';
import { Doughnut, Bar } from 'react-chartjs-2';
import './index.css';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
ChartJs.register( CategoryScale,
  LinearScale,
  BarElement,
  Title,
   ArcElement,
  Tooltip,
  Legend);

export default function PreScreen({userId,applicationId,shouldFetchData=true}) {
const urlExperian = `/experian/report?userId=${userId}&applicationId=${applicationId}`
 const [loading,setLoading] = useState(false)
 const [error, setError] = useState("");
 const [experianReport,setExperianReport]=useState(null)
 const [reInvokeModal, setReInvokeModal] = useState(false); // New state for retry modal
 const [newMobileNumber, setNewMobileNumber] = useState(''); // New state for mobile input
 const [isLoading, setIsLoading] = useState(false); // New state for loader
 const [confirmModal, setConfirmModal] = useState(false);
 const decode = useCurrentUser();
 const user = null;
 // Memoize fetchData to avoid unnecessary re-creations in useEffect dependencies
 const fetchData = useCallback(async () => {
   setError(null);
   setLoading(true);
   try {
     const [cibilResponse] = await Promise.all([
       axiosInstance.get(urlExperian, {
         // signal: controller.signal, // Removed signal here as it's passed below in useEffect
       }),
     ]);
     setExperianReport(cibilResponse?.data?.data?.summary);
     setLoading(false)
   } catch (err) {
     if (err.name !== 'CanceledError') {
       console.error("Failed to fetch data:", err);
       setError("Could not load data. Please try again.");
     }
   }
 }, [urlExperian]); // Dependencies for useCallback

  useEffect(() => {
    if (!shouldFetchData) return;  
    
    const controller = new AbortController();
    // Re-fetch data using the memoized fetchData
    fetchData(controller); // Pass controller if still needed for initial fetch (adjust fetchData if so)

    return () => {
      controller.abort();
    };
    
  }, [fetchData, shouldFetchData]); // Dependency array includes memoized fetchData

const ref=useRef(null)
 const optionsBar = {
  plugins: {
    
  },
 
  responsive: true,
  
  borderRadius:8,
  scales: {
    x: {
      stacked: true,
      grid:{
        drawOnChartArea:false
      },

    },
    y: {
      stacked: true,
      min:0,
       
      ticks: {
      stepSize: 1,
      },
    },
  },
};

// These labels depend on experianReport being an object,
// so they will be undefined if experianReport is a string.
// This is fine as the rendering will be conditional.
const labels = experianReport?.emiGraphCoordinates?.months?.map((item)=>{
  return(
  `${item.substr(0,2)}-${item.substr(5,7)}`
)
}
);

 const dataBar = {
  labels,
  datasets: [
    {
      label: 'On Time',
      data: experianReport?.emiGraphCoordinates?.paid,
      backgroundColor: '#579AFD',
      barPercentage: 0.9,
      categoryPercentage: 1,
      
    },
    {
      label: 'Delayed',
      data: experianReport?.emiGraphCoordinates?.unpaid,
      backgroundColor: '#FAA21E',
      barPercentage: 0.9,
      categoryPercentage: 1,
      
    },
   
  ],
};
const data = {
  labels: [],
  datasets: [
    {
      label: 'score',
      data:[experianReport?.score,1000-experianReport?.score],
      radius:130,
      backgroundColor: [experianReport?.score>700?'#12B76A':experianReport?.score>650&&experianReport?.score<=700?'yellow':experianReport?.score>575 &&experianReport?.score<=650?'orange':'red','white'] ,
      borderColor:[ experianReport?.score>700?'#12B76A':experianReport?.score>650&&experianReport?.score<=700?'yellow':experianReport?.score>575 &&experianReport?.score<=650?'orange':'red','#D0D0D0'] ,
      borderWidth: 1,
      circumference:180,
      rotation:270
    },
  ],

};

  const prev = () => {
    requestAnimationFrame(() => {
      const scrollLeft = ref.current?.scrollLeft;
      const itemWidth = parseInt(
        getComputedStyle(ref.current?.children[0]).width
      );
      ref.current.scrollLeft = scrollLeft - itemWidth * 3;
    });
  };

  const next = () => {
    requestAnimationFrame(() => {
      const scrollLeft = ref.current?.scrollLeft;
      const itemWidth = parseInt(
        getComputedStyle(ref.current?.children[0]).width
      );
      ref.current.scrollLeft = scrollLeft + itemWidth * 3;
    });
  };
  function Balance(amount) {
    
    if (amount === undefined) {
      return " "; 
    }
    amount = parseFloat(amount.toString().replace(/,/g, ''));
      if (amount >= 10000000) return `${parseFloat((amount / 10000000).toFixed(2))} Cr`;
      if (amount >= 100000) return `${parseFloat((amount / 100000).toFixed(2))} L`;
      if (amount >= 1000) return `${parseFloat((amount / 1000).toFixed(2))} K`;
      return amount?.toLocaleString('en-IN');
    }
    const currentBalance = experianReport?.currentBalance;
  const formattedCurrentBalance = Balance(currentBalance);
  
  const totalBalance = experianReport?.totalBalance;
  const formattedTotalBalance = Balance(totalBalance);

  const [modal, setModal] = useState(false);
  const [cibilUrl,setCibilUrl] = useState(null);

  const toggle1 = () => {
    // This function will only be called if the download button (which triggers it) is rendered.
    // The download button is part of the full report UI, so it won't be visible if experianReport is a string.
    if(experianReport?.experianReportLink || experianReport?.crifReportLink){
      let reportLink = experianReport?.experianReportLink
      if(decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'){
        reportLink = 'crif_report_file/' + experianReport?.crifReportLink?.split("/")?.pop()
      }
      const url = `/file/url-content?path=${reportLink}`
      axiosInstance
          .get(url, {
            headers: {
            },
          })
          .then((res)=>{
            setCibilUrl(res?.data?.data)
            }).catch((err)=>(err))
    }

    setModal(!modal)
  };

  // New toggle function for the retry modal
  const toggleReInvokeModal = () => {
    setReInvokeModal(!reInvokeModal);
    if (!reInvokeModal) { // When opening, clear previous input
      setNewMobileNumber('');
    }
  };

  // New handler for retry submission
  const handleRetrySubmit = async () => {
    setIsLoading(true); // Start loader

    const payload = {
      userId: userId,
      applicationId: applicationId,
      mobile: newMobileNumber,
    };

    try {
      const response = await axiosInstance.post('/admin/application/create-experian', payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      alert("Experian report re-invocation successful! Refreshing data...");
      toggleReInvokeModal(); // Close the modal
      fetchData(); // Re-fetch the Experian report to update the UI
      window.location.reload();
      
    } catch (apiError) {
      console.error("Error re-invoking Experian report:", apiError);
      alert(`Failed to re-invoke report: ${apiError.response?.data?.message || apiError.message}`);
    } finally {
      setIsLoading(false); // Stop loader
    }
  };

  function formatNumberWithCommas(number) {
    if (number === undefined || number === null) return "--";
    return number.toLocaleString('en-IN'); 
  }

  return (
    <>
    {/* Confirmation Modal */}
    <Modal isOpen={confirmModal} toggle={() => setConfirmModal(false)} centered>
      <ModalHeader toggle={() => setConfirmModal(false)}>Confirm Action</ModalHeader>
      <ModalBody>
        <p style={{ fontSize: '16px', color: '#333', marginBottom: '1.5em' }}>
          Experian report has not been triggered yet for this user. Do you want to trigger a new Experian report?
        </p>
        <div style={{ textAlign: 'right' }}>
          <Button 
            color="secondary" 
            onClick={() => setConfirmModal(false)} 
            style={{ marginRight: '10px' }}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "#D32028", border: 'none' }}
            onClick={() => {
              setConfirmModal(false);
              toggleReInvokeModal();
            }}
          >
            Yes, Trigger
          </Button>
        </div>
      </ModalBody>
    </Modal>

{/* Existing re-invoke modal below... */}
      {loading ? (
          <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%' }}>
              <CircularProgress />
          </Box>
        ):(
          <>
          {error && <div className="error-message" style={{ color: 'red', padding: '1em', margin: '1em' }}>{error}</div>}
      {/* Conditional rendering based on the type of experianReport */}
      {experianReport && typeof experianReport === 'string' ? (
        // Display summary text if experianReport is a string
        <div style={{
          padding: '2em',
          margin: '1em',
          borderRadius: '1em',
          boxShadow: '0px 0px 2px 2px #f0f0f0',
          backgroundColor: '#fff',
          fontFamily: 'Outfit',
          lineHeight: '1.5',
          textAlign: 'center'
        }}>
          <p style={{ color: '#D32028', fontWeight: 'bold', fontSize: '20px', marginBottom: '1em' }}>
            Report Generation Failed
          </p>
          <p style={{ fontSize: '16px', color: '#333' }}>
            {experianReport}
          </p>
          <p style={{ fontSize: '14px', color: '#666', marginTop: '1em' }}>
            Please check the details and try again.
          </p>
          <Button 
            onClick={toggleReInvokeModal} 
            style={{ marginTop: '1.5em', padding: '10px 20px', fontSize: '16px',backgroundColor:"#D32028",border:'none' }}
          >
            Retry with New Mobile Number
          </Button>
        </div>
      ) :(!experianReport && !error?<><div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ marginBottom: '16px', fontSize: '16px', color: '#555' }}>
              Experian has not been triggered for the user.
          </div>
          <Button
          style={{ marginTop: '1.5em', padding: '10px 20px', fontSize: '16px', backgroundColor: "#D32028", border: 'none' }}
          onClick={() => setConfirmModal(true)}
        >
          Trigger Experian
        </Button>
        </div></>:( <> {/* This fragment correctly wraps all report content */}
          <div style={{display:'block'}}> {/* This div now wraps the top sections */}
            <div style={{display:'flex',justifyContent: 'space-between', }}>
              <Modal isOpen={modal}  size="xl" style={{height:'100%'}}>
              <ModalHeader toggle={toggle1}>{decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'? 'Crif': 'Cibil'}</ModalHeader>
              <ModalBody >
              <iframe title='cibil'
                  src={cibilUrl}
                  width="100%"
                  height="1000vh"
                  style={{ border: 'none' }}
                ></iframe>
              </ModalBody>
              </Modal>
          
                  <div style={{borderRadius:'1em',width:'80%',margin:'1em',boxShadow:'0px 0px 2px 2px  #f0f0f0'}}>
                    <div style={{display:'flex',justifyContent:'space-around',}}>
                      <div style={{display:'flex',justifyContent: 'space-between',padding:'1em',width:'100%',borderBottom:'1px solid #f0f0f0'}}>
                      <p style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit'}}><img style={{marginRight:'0.5em'}} alt="" src={bankImg}/>{decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'? 'Experian': 'Experian'} Score</p>
                      
                      </div>
        
                    </div>
                     <div style={{padding:'1em',paddingLeft:'1em',paddingRight:'1em',marginTop:'2em'}}>
        
                    <div style={{display:'block'}}>
                      <div style={{display:'flex',justifyContent: 'space-around', }}>
                        <div style={{display:'block',marginTop:'-4em',}}>
                          <p style={{position:'absolute',marginLeft:'3em',marginTop:'2em',textAlign:'center',fontFamily:'Outfit',fontWeight:'bold',fontSize:"19px",}}>{experianReport?.vintage}</p>
                        <div>
                         <Doughnut redraw={true} options={
                          {
                            responsive:true,
                            maintainAspectRatio:true
                          }
                         }  data={data}/> 
                        </div>
                         <div style={{lineHeight:'1.5em',marginTop:'-5em'}}>
                         <p style={{textAlign:'center',fontSize:'25px',fontWeight:'bold'}}><span style={{fontWeight:'bad',padding:'5px',borderRadius:'5px',}}>{experianReport?.score}</span></p>
                        </div>
                          
                        </div>
                        <div style={{display:'block',paddingRight:'5%',}}>
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                              <div style={{display:'block',lineHeight:'1em',width:'10em'}}>
                                  <p style={{color:'#667085'}}>Accounts</p>
                                  <p style={{fontWeight:'bold'}}> {experianReport?.activeNumberOfAccounts} / {experianReport?.totalNumberOfAccounts}</p>
                                  <p style={{fontSize:'11px',backgroundColor:'#F0F0F0',textAlign:'center',borderRadius:'1em'}}>Active/Total</p>
                              </div>
                              
                            {/* <div style={{display:'block', lineHeight:'1em',width:'8em'}}>
                                  <p style={{color:'#667085',marginRight:'2em'}}>Overdue</p>
                                  <p style={{fontWeight:'bold'}}>{experianReport?.overdueAccount}/{experianReport?.overdueAmount}</p>
                                  <p style={{fontSize:'11px',backgroundColor:'#F0F0F0',textAlign:'center',borderRadius:'1em',width:'10em'}}>Count/Amount</p>
                            </div> */}
                              <div style={{display:'block',lineHeight:'1em',width:'10em'}}>
                                  <p style={{color:'#667085',textAlign:'center',marginRight:'2em'}}>Balance</p>
                                  <p style={{fontWeight:'bold',width:'10em',marginLeft:'2em'}}>{formattedCurrentBalance} / {formattedTotalBalance}</p>
                                  <p style={{fontSize:'11px',backgroundColor:'#F0F0F0',marginLeft:'3em',borderRadius:'1em',textAlign:'center'}}>Current/Sanctioned</p>
                            </div>
                         </div>
                        <div style={{display:'block',lineHeight:'1em',width:'10em'}}>
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                              <div style={{display:'block',width:'8em'}}>
                                  <p style={{color:'#667085',width:'8em'}}>Repayments P.M</p>
                                  <p style={{fontWeight:'bold'}}>{
                                    Balance(Math.round(
                                            Number(
                                              experianReport?.obligations?.data?.meta?.eligibility?.obligationAtStart
                                            ) || 0
                                          )
                                      || 0)
                                          }</p>
                              </div>
                              <div style={{display:'block',lineHeight:'1em',marginLeft:'2em',width:'12em'}}>
                                  <p style={{color:'#667085',marginLeft:'2em'}}>Deliquencies</p>
                                  <p style={{fontWeight:'bold',color:'#D32028',marginLeft:'2em'}}>{experianReport?.deliquencyCount?experianReport?.deliquencyCount:'--'} / {experianReport?.highestOverdueDays?experianReport?.highestOverdueDays:'--'} / {experianReport?.overdueCount?experianReport?.overdueCount:'--'}</p>
                                  <p style={{padding:'2px',fontSize:'11px',backgroundColor:'#F0F0F0',textAlign:'center',borderRadius:'1em',width:'12em',marginLeft:'3em'}}>Count / Highest Days / No. of Overdue Accounts</p>
                            </div>
                          
                        </div>
                      </div>
                         
                      </div>
                      </div>
                      <div style={{display:'flex',justifyContent: 'space-between',marginLeft:'4%',marginRight:'4%'}}>
                            <div style={{display:'block',lineHeight:'1.5em'}}>
                              <p>Overdue</p>
                              <p style={{textAlign:'center',color:experianReport?.overdueAccount||experianReport?.overdueAmount?"#d32028":"#12B76A",fontSize:"18px"}}>{experianReport?.overdueAmount||experianReport?.overdueAccount?<span> &#8377;{experianReport?.overdueAmount?.toLocaleString('en-IN')} / {experianReport?.overdueAccount}</span>:"NIL"}</p>
                            </div>
                            <div style={{display:'block',lineHeight:'1.5em'}}>
                              <p>Write Offs</p>
                              <p style={{textAlign:'center',color:experianReport?.writeOffs?"#d32028":"#12B76A",fontSize:"18px"}}> {experianReport?.writeOffs||experianReport?.writeOffAmount?<span> &#8377;{experianReport?.writeOffAmount?.toLocaleString('en-IN')} /  {experianReport?.writeOffs} </span>:"NIL"}</p>
                            </div>
                            <div style={{display:'block',lineHeight:'1.5em'}}>
                              <p>Settlement</p>
                              <p style={{textAlign:'center',color:experianReport?.settlementAmount||experianReport?.settlements?"#d32028":"#12B76A",fontSize:"18px"}}>{experianReport?.settlementAmount||experianReport?.settlements?<span> &#8377;{experianReport?.settlementAmount?.toLocaleString('en-IN')} /  {experianReport?.settlements} </span> :"NIL"}</p>
                            </div>
                            <div style={{display:'block',lineHeight:'1.5em'}}>
                              <p>Suites</p>
                              <p style={{textAlign:'center',color:experianReport?.suitAccounts?"#d32028":"#12B76A",fontSize:"18px"}}>{experianReport?.suitAccounts?`${experianReport?.suitAccounts}`:"NIL"}</p>
                            </div>
                            
                            
                      </div>
        
                      
                        
                      </div>
                    
                      </div>
        
                  </div>
                  <div style={{borderRadius:'1em',width:'50%',margin:'1em',boxShadow:'0px 0px 2px 2px  #f0f0f0'}}>
                    <div style={{display:'flex',justifyContent:'space-around',}}>
                      <div style={{display:'flex',justifyContent: 'space-between',padding:'1em',width:'100%',borderBottom:'1px solid #f0f0f0'}}>
                      <p style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit'}}><img style={{marginRight:'0.5em'}} alt="" src={phone}/>Contact Info <img style={{marginLeft:'5px'}} alt=""/></p>
                      
                      </div>
        
                    </div>
                     <div style={{padding:'1em'}}>
                     
        
                      <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    rowGap: '0.5rem',
                    columnGap: '1rem',
                    padding: '1em',
                  }}>
                    {experianReport?.demographicData?.telephones?.map((item, index) => (
                      <div key={index}>
                        <p style={{color: '#667085', margin: '0 0 0.2em 0', fontSize: '13px'}}>
                          Alternate Number {index}
                        </p>
                        <p style={{margin: 0, fontWeight: '500'}}>{item}</p>
                      </div>
                    ))}
                    {experianReport?.demographicData?.emails?.map((item, index) => (
                      <div key={`email-${index}`} style={{minWidth:0}}>
                        <p style={{color:'#667085',margin:'0 0 0.2em 0',fontSize:'13px'}}>Email {index}</p>
                        <p style={{margin:0,fontWeight:'500',wordBreak:'break-word',overflowWrap:'break-word'}}>{item}</p>
                      </div>
                    ))}
                  </div>
                </div>
        
                  </div>
              </div>
              <div style={{display:'flex', gap:'1em', margin:'1em'}}>

                  {/* Account Summary */}
                  <div style={{flex:'2.5 1 0',minWidth:0,borderRadius:'1em',boxShadow:'0px 0px 2px 2px #f0f0f0'}}>
                    <div style={{padding:'1em',borderBottom:'1px solid #f0f0f0'}}>
                      <p style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit'}}><img style={{marginRight:'0.5em'}} src={AccountSum} alt=""/>Account Summary</p>
                    </div>
                    <div style={{padding:'1em'}}>
                      <div style={{display:'flex',gap:'2em'}}>
                        <div style={{flex:1,lineHeight:'1.5em'}}>
                          <p style={{color:'#667085'}}>Total Accounts</p>
                          <p style={{fontWeight:'bold',color:'#D32028',fontSize:'30px'}}>{experianReport?.totalNumberOfAccounts}</p>
                        </div>
                        <div style={{flex:1,lineHeight:'1.5em'}}>
                          <p style={{color:'#667085'}}>Ovd. Account</p>
                          <p style={{fontWeight:'bold',color:'#D32028',fontSize:'30px'}}>{experianReport?.overdueAccount}</p>
                        </div>
                        <div style={{flex:1,lineHeight:'1.5em'}}>
                          <p style={{color:'#667085'}}>Zero Bal Accnt.</p>
                          <p style={{fontWeight:'bold',color:'#D32028',fontSize:'30px'}}>{experianReport?.activeNumberOfAccounts||experianReport?.totalNumberOfAccounts?experianReport.totalNumberOfAccounts-experianReport.activeNumberOfAccounts:"--"}</p>
                        </div>
                      </div>
                      <div style={{display:'flex',gap:'2em',marginTop:'1.5em'}}>
                        <div style={{flex:1,lineHeight:'1.5em'}}>
                          <p style={{color:'#667085'}}>High Sanc Amt.</p>
                          <p style={{fontWeight:'bold',fontSize:'18px'}}>&#8377;{experianReport?.highestSanctionedAmount?formatNumberWithCommas(experianReport.highestSanctionedAmount):"--"}</p>
                        </div>
                        <div style={{flex:1,lineHeight:'1.5em'}}>
                          <p style={{color:'#667085'}}>Current Bal.</p>
                          <p style={{fontWeight:'bold',fontSize:'18px'}}>&#8377;{experianReport?.currentBalance}</p>
                        </div>
                        <div style={{flex:1,lineHeight:'1.5em'}}>
                          <p style={{color:'#667085'}}>Ovd Bal.</p>
                          <p style={{fontWeight:'bold',fontSize:'18px'}}>&#8377;{experianReport?.overdueAmount?.toLocaleString("en-IN")}</p>
                        </div>
                      </div>
                      <div style={{display:'flex',gap:'2em',marginTop:'1.5em'}}>
                        <div style={{flex:1,lineHeight:'1.5em'}}>
                          <p style={{color:'#667085'}}>Latest Account</p>
                          <p style={{fontWeight:'bold',fontSize:'18px'}}>{experianReport?.recentAccountDate?moment(experianReport.recentAccountDate).format('DD MMM YYYY'):"--"}</p>
                        </div>
                        <div style={{flex:1,lineHeight:'1.5em'}}>
                          <p style={{color:'#667085'}}>Secured</p>
                          <p style={{fontWeight:'bold',fontSize:'18px'}}>&#8377;{formatNumberWithCommas(Math.round(experianReport?.obligations?.data?.sanction_summary?.secured_sanction_amount??0))}</p>
                        </div>
                        <div style={{flex:1,lineHeight:'1.5em',minWidth:0}}>
                          <p style={{color:'#667085'}}>Gold / Unsecured</p>
                          <p style={{fontWeight:'bold',fontSize:'18px',whiteSpace:'nowrap'}}>&#8377;{formatNumberWithCommas(Math.round(experianReport?.obligations?.data?.sanction_summary?.gold_sanction_amount??0))} / &#8377;{formatNumberWithCommas(Math.round(experianReport?.obligations?.data?.sanction_summary?.unsecured_sanction_amount??0))}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Obligations Summary */}
                  <div style={{flex:'1.5 1 0',minWidth:0,borderRadius:'1em',boxShadow:'0px 0px 2px 2px #f0f0f0'}}>
                    <div style={{padding:'1em',borderBottom:'1px solid #f0f0f0'}}>
                      <p style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit'}}>
                        <img style={{marginRight:'0.5em'}} src={Enquiries} alt=""/>Obligations Summary
                      </p>
                    </div>
                    <div style={{padding:'1em'}}>
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',rowGap:'1em',columnGap:'2em'}}>
                        {experianReport?.obligations?.data?.structured_obligations &&
                          Object.entries(experianReport.obligations.data.structured_obligations)
                            .filter(([key, value]) => key !== 'total_obligations' && (value?.total_obligation ?? 0) !== 0)
                            .map(([key, value]) => {
                              const secured = Math.round(value?.secured?.['total_secured_obligation'] ?? 0);
                              const unsecured = Math.round(value?.unsecured?.['total_unsecured_obligation'] ?? 0);
                              return (
                                <React.Fragment key={key}>
                                  <div style={{gridColumn:'1 / -1',lineHeight:'1.5em'}}>
                                    <p style={{color:'#667085'}}>
                                      {key.replace(/_/g,' ').replace(/\b\w/g, l => l.toUpperCase())}
                                    </p>
                                    <p style={{fontWeight:'bold',color:'#d32028',fontSize:'25px'}}>
                                      &#8377;{formatNumberWithCommas(Math.round(value?.total_obligation ?? 0))}
                                    </p>
                                  </div>
                                  <div style={{lineHeight:'1.5em'}}>
                                    <p style={{color:'#667085'}}>Secured</p>
                                    <p style={{fontWeight:'bold',fontSize:'20px'}}>&#8377;{formatNumberWithCommas(secured)}</p>
                                  </div>
                                  <div style={{lineHeight:'1.5em'}}>
                                    <p style={{color:'#667085'}}>Unsecured</p>
                                    <p style={{fontWeight:'bold',fontSize:'20px'}}>&#8377;{formatNumberWithCommas(unsecured)}</p>
                                  </div>
                                </React.Fragment>
                              );
                            })}
                      </div>
                      {(() => {
                        const yw = experianReport?.obligations?.data?.time_based_borrowing_analysis?.year_wise_distribution;
                        const y1 = yw?.['1_years'];
                        const y3 = yw?.['3_years'];
                        if (!y1 && !y3) return null;
                        return (
                          <>
                            <hr style={{border:'none',borderTop:'1px solid #f0f0f0',margin:'1em 0'}} />
                            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',columnGap:'2em'}}>
                              <div style={{lineHeight:'1.5em'}}>
                                <p style={{color:'#667085',marginBottom:'0.25em',fontSize:'13px'}}>Last 1 Year</p>
                                <p style={{fontWeight:'bold',fontSize:'18px',marginBottom:'0.25em'}}>
                                  {Balance(y1?.cumulative_secured_borrowed_amount ?? 0)} / {Balance(y1?.cumulative_unsecured_borrowed_amount ?? 0)}
                                </p>
                                <span style={{fontSize:'11px',color:'#667085',background:'#f2f4f7',borderRadius:'999px',padding:'2px 10px',display:'inline-block'}}>Secured/Unsecured</span>
                              </div>
                              <div style={{lineHeight:'1.5em'}}>
                                <p style={{color:'#667085',marginBottom:'0.25em',fontSize:'13px'}}>Last 3 Years</p>
                                <p style={{fontWeight:'bold',fontSize:'18px',marginBottom:'0.25em'}}>
                                  {Balance(y3?.cumulative_secured_borrowed_amount ?? 0)} / {Balance(y3?.cumulative_unsecured_borrowed_amount ?? 0)}
                                </p>
                                <span style={{fontSize:'11px',color:'#667085',background:'#f2f4f7',borderRadius:'999px',padding:'2px 10px',display:'inline-block'}}>Secured/Unsecured</span>
                              </div>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>


              </div>

                  <div style={{borderRadius:'1em',width:'99%',margin:'1em', boxShadow:'0px 0px 2px 2px  #f0f0f0'}}>
                    <div style={{display:'flex',justifyContent:'space-around',}}>
                      <div style={{display:'flex',justifyContent: 'space-between',padding:'1em',width:'100%',borderBottom:'1px solid #f0f0f0'}}>
                      <p style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit',}}><img style={{marginRight:'0.5em'}} src={customerInfo} alt=""/>Customer Information</p>
                      
                      </div>
        
                    </div>
                     <div style={{padding:'1em'}}>
                     
        
                      <div style={{display:'flex',justifyContent:'space-between',padding:'1em' }}>
                      <div style={{display:'block' ,lineHeight:'1em',width:'100%',borderBottom:'1px solid #f0f0f0'}}>
                            <div style={{display:'flex',justifyContent: 'space-between',}}>
                              <div style={{display:'block'}}>
                                  <p style={{color:'#667085'}}>Name</p>
                                  <p style={{fontWeight:'bold',color:'#D32028'}}>{experianReport?.name}</p>
                              </div>
                            <div style={{display:'block',lineHeight:'1em'}}>
                                  <p style={{color:'#667085'}}>DOB </p>
                                  <p style={{fontWeight:'bold',color:'#D32028'}}>{moment(experianReport?.dob).format('DD-MMM-YYYY')}</p>
                                
                            </div>
                            <div style={{display:'block',lineHeight:'1em'}}>
                                  <p style={{color:'#667085'}}>Gender</p>
                                  <p style={{fontWeight:'bold',color:'#D32028'}}>{experianReport?.gender}</p>
                                
                            </div>
                            <div style={{display:'block',lineHeight:'1em'}}>
                                  <p style={{color:'#667085'}}>Date</p>
                                  <p style={{fontWeight:'bold',color:'#D32028'}}>{experianReport?.processesDateTime?moment(experianReport?.processesDateTime?.substr(0,10)).format('DD-MMM-YYYY'):"--"}</p>
                                
                            </div>
                            <div style={{display:'block',lineHeight:'1em'}}>
                                  <p style={{color:'#667085'}}>Time</p>
                                  <p style={{fontWeight:'bold',color:'#D32028'}}> {experianReport?.processesDateTime?experianReport?.processesDateTime.substr(11,experianReport?.processesDateTime.length):"--"}</p>
                                
                            </div>
                        </div>
                      </div>
                      </div>
                      <div style={{display:'block' ,lineHeight:'1em',width:'100%',borderBottom:'1px solid #f0f0f0'}}>
                          
                              <div class="slides">
        
        
                        
                              { experianReport?.ids?.map((item)=>{
                                return(
                                  <div>
                                  
                                  <div style={{lineHeight:'1em',margin:'3em'}}>
                                  <p style={{marginLeft:'2em'}}>{item.type}</p>
                                  <p style={{color:'#D32028',marginLeft:'2em'}}>{item.id}</p>
                                  </div>
                                </div>
                                )
                                }) }
                              
                        </div>
                    
                      </div>
                    
                    
                </div>
                
        
                  </div>
          </div> {/* CLOSING the div style={{display:'block'}} HERE */}
          
          {/* Accordions now follow correctly within the fragment */}
          <Accordion defaultExpanded={true} style={{marginTop:'1em',marginBottom:'1em'}}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography><img style={{marginRight:'1em'}}src={monthwise} alt=""/><span style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit'}} >Account Vs EMI History</span></Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                  <div style={{display:'flex',justifyContent: 'center',}}>
                  <img style={{width:'40em',marginTop:'1em',marginBottom:'2em'}} src={legend} alt=""/>
                </div>
                <div style={{display:'block',justifyContent: 'flex-start',}}>
                    { experianReport?.accounts?.map((item)=>{
                  return(
                
                  <ul style={{listStyle:'none',display:'flex',flexDirection: 'row',borderBottom:'1px dashed #D0D0D0',paddingLeft:'0px',paddingBottom:'1em',paddingTop:'1em',lineHeight:'1em'}}>
                  
                    <li title={item?.dateClosed?"Closed":"Active"}style={{width:'15em'}}><span style={{
                        borderRadius:'15px',
                        padding:'4px 8px', // Added horizontal padding for better visual
                        backgroundColor:item?.dateClosed?"#898989":"#ECFDF3",
                        color:item?.dateClosed?"white":"#12B76A",
                        display: 'inline-block' // Ensures padding and border-radius work as expected
                    }}>
                        {item.accountType} - {item.subscriberName}
                    </span></li>
                    {item.paymentHistory1.map((item)=>{
                      
                      if(item.dpd===null )
                      {
                        return (
                        <collections.TooltipCredit title={`No Record`} placement="top" arrow>
                          <li  style={{backgroundColor:'#D0D0D0',width:'8px',borderRadius:'15em',marginLeft:'1%',height:'8px'}}></li>
                        </collections.TooltipCredit>
                      
                        )
                      }
                      else if((item.dpd)==="000" ||item.dpd==="XXX" || item.dpd==="00S")
                      {
        
                        return (
                          <collections.TooltipCredit title={`No Delay ,  ${item.month}`} placement="top" arrow>
                        <li  style={{backgroundColor:'#12B76A',width:'8px',borderRadius:'15em',marginLeft:'1%',height:'8px'}}></li>
                        </collections.TooltipCredit>
                        
                        )
                      }
                      else if((parseInt(item.dpd)>30)||item.dpd==="00D"|| item.dpd==="00B" || item.dpd ==="00M" || item.dpd ==="00L")
                      {
                        return (
                        <collections.TooltipCredit 
                          title={
                            item.dpd === "00D" ? `${item.month}, Doubtful` :
                            item.dpd === "00B" ? `${item.month}, Substandard` :
                            item.dpd === "00S" ? `${item.month}, Standard` :
                            item.dpd === "00M" ? `${item.month}, Special Mention Account` :
                            item.dpd === "00L" ? `${item.month}, Loss` :
                            `${item.month}, ${parseInt(item.dpd)} days delay`
                          } 
                          placement="top" 
                          arrow
                        >                        
                        <li style={{backgroundColor:'red',width:'1vw',borderRadius:'15em',marginTop:'-0.2em',marginLeft:'1%',height:'1vw'}}></li>
                        </collections.TooltipCredit>
                      
                        )
                      }
                      else if(parseInt(item.dpd)<=30 && parseInt(item.dpd)>0)
                      {
                        return (
                          <collections.TooltipCredit title={`${item.month},${parseInt(item.dpd)} days delay`} placement="top" arrow>
                        <li  style={{backgroundColor:'orange',width:'12px',borderRadius:'15em',marginLeft:'1%',height:'12px'}}></li>
                        </collections.TooltipCredit>
                        )
                      }
                    }
                    )}
                    {item.paymentHistory2.map((item)=>{
                      if(item.dpd===null  )
                      {
                        return (
                            <collections.TooltipCredit title={`No Record`} placement="top" arrow>
                              <li   style={{backgroundColor:'#D0D0D0',width:'8px',borderRadius:'15em',border:'1px solid #C0C0C0',marginLeft:'1%',height:'8px'}}></li>
                          </collections.TooltipCredit>
                      
                        )
                      }
                      else if((item.dpd)==="000" ||item.dpd==="XXX" || item.dpd==="00S")
                      {
        
                        return (
                          <collections.TooltipCredit title={`No Delay ,  ${item.month}`} placement="top" arrow>
                            <li  style={{backgroundColor:'#12B76A',width:'8px',borderRadius:'15em',marginLeft:'1%',height:'8px'}}></li>
                          </collections.TooltipCredit>
                        
                        )
                      }
                      else if((parseInt(item.dpd)>30)||item.dpd==="00D"|| item.dpd==="00B" || item.dpd ==="00M" || item.dpd ==="00L")
                      {
                        return (
                        <collections.TooltipCredit 
                          title={
                            item.dpd === "00D" ? `${item.month}, Doubtful` :
                            item.dpd === "00B" ? `${item.month}, Substandard` :
                            item.dpd === "00S" ? `${item.month}, Standard` :
                            item.dpd === "00M" ? `${item.month}, Special Mention Account` :
                            item.dpd === "00L" ? `${item.month}, Loss` :
                            `${item.month}, ${parseInt(item.dpd)} days delay`
                          } 
                          placement="top" 
                          arrow
                        >                            
                        <li style={{backgroundColor:'red',width:'1vw',borderRadius:'15em',marginTop:'-0.2em',marginLeft:'1%',height:'1vw'}}></li>
                          </collections.TooltipCredit>
                      
                        )
                      }
                      else if((parseInt(item.dpd)<=30 && parseInt(item.dpd)>0 ))
                      {
                        return (
                          <collections.TooltipCredit title={`${item.month},${parseInt(item.dpd)} days delay`} placement="top" arrow>
                            <li  style={{backgroundColor:'orange',width:'12px',borderRadius:'15em',marginLeft:'1%',height:'12px'}}></li>
                          </collections.TooltipCredit>
                        
                        )
                      }
                    }
                    )}
                  </ul>
                    
                )
                }
                )
                }
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>      
        
        <Accordion style={{marginTop:'1em',marginBottom:'1em'}}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography><img style={{width:'1.8em',height:'1.8em',marginRight:'1em'}} alt="" src={address}/><span style={{fontWeight:'bold',fontSize:'18px'}}>Address</span></Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div style={{ marginTop:'9em',marginLeft:'1em',position:'absolute'}}>
                <img onClick={()=>prev()} className="sliderBack" src={slider} alt=""/>
              </div>
                <div ref={ref}  style={{marginLeft:'2%',scrollBehavior:'smooth',padding:'1em',overflowX: 'hidden',display:'flex',whiteSpace:'nowrap',width:'94%'}}>
                  
                  {
                  experianReport?.demographicData?.addresses.map((item)=>{
                    return(
                  <div style={{backgroundColor:'#fff5f5',borderRadius:'1em',width:'26em',margin:'1em', boxShadow:'0px 0px 2px 2px  #F9D8D6'}}>
                <div style={{display:'flex',justifyContent:'space-around',}}>
                  <div style={{display:'flex',justifyContent: 'space-between',padding:'1em',width:'100%',borderBottom:'1px solid #F9D8D6'}}>
                  <p style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit',color:'#D32028'}}>{item.category}</p>
                  
                  </div>
        
                </div>
                
                <div style={{padding:'1em',height:'12em'}}>
                
                  <div style={{display:'block', borderBottom:'2px dashed #F9D8D6'}}>
                        <div style={{display:'flex',width:'100%',}}>
                          
                              <p style={{color:'#667085',width:'25em' ,textWrap:'wrap',overflowY: 'scroll',height:'4em',}}>{item.area} , {item.state}</p>
                              
                          
                        
                    </div>
                
                  
                  </div>
                  <div style={{display:'block' }}>
                        <div style={{display:'flex',width:'100%',justifyContent: 'space-between',marginTop:'0.5em'}}>
                          <div style={{display:'block',lineHeight:'1.5em'}}>
                              <p style={{color:'#667085'}}>Residence Code</p>
                              <p style={{fontWeight:'bold',color:'#D32028'}}>{item.residenceType}</p>
                          </div>
                        <div style={{display:'block',lineHeight:'1.5em'}}>
                              <p style={{color:'#667085',}}>Date Reported</p>
                              <p style={{fontWeight:'bold',color:'#D32028'}}>{item.reportedOn}</p>
                            
                        </div>
                    </div>
                
                  
                  </div>
            </div>
              
          </div>
                    )
                  }) }
        
          </div>
        
              <div style={{ marginTop:'-13em',position:'absolute',right:'2em',}}>
                <img onClick={()=>next()} style={{cursor:'pointer',}} src={slider} alt=""/>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
          
        <Accordion style={{marginTop:'1em',marginBottom:'1em'}}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography><img style={{marginRight:'1em'}}src={employee} alt=""/><span style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit'}}>Employment Info</span></Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
                <Table>
                <thead style={{backgroundColor:'#f0f0f0', }} >
                  <th style={{textAlign:'center'}} >Account Type </th>
                  <th>Date Reported</th>
                  <th>Income</th>
                  <th>Occupation</th>
                  <th>Net/Gross Income Indicator</th>
                  <th>Monthly/Annual Income Indicator</th>
                </thead>
                <tbody >
            
                  <tr >
                    <td style={{textAlign:'center'}}>{experianReport?.demographicData?.accountType}</td>
                    <td>{experianReport?.demographicData?.dateReported?moment(experianReport?.demographicData?.dateReported).format("DD MMM YYYY"):"--"}</td>
                    <td>{experianReport?.demographicData?.income?experianReport?.demographicData?.income:"--"}</td>
                    <td>{experianReport?.demographicData?.employment?experianReport?.demographicData?.employment:"--"}</td>
                    <td>NA</td>
                    <td>NA</td>
                  </tr>
                
                </tbody>
              </Table>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion style={{marginTop:'1em',marginBottom:'1em'}}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography><img style={{marginRight:'1em'}}src={accountInfo} alt=""/><span style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit'}}>Account Info</span></Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div style={{overflowX: 'scroll',whiteSpace:'nowrap'}}>
              <Table  >
                <thead style={{backgroundColor:'#f0f0f0',}} >
                  <th style={{textAlign:'center',padding:'1em'}} >Account Type </th>
                  <th style={{textAlign:'center',padding:'1em'}}>Ownership</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Date Opened</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Date Closed</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Collateral Type</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Sanc. Amount</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Current Balance</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Overdue</th>
                  <th style={{textAlign:'center',padding:'1em'}}>EMI</th>
                  <th style={{textAlign:'center',padding:'1em'}}>PMT Freq.</th>
                  <th style={{textAlign:'center',padding:'1em'}}>R.PMT Tenure</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Interest Rate</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Actual Payment</th>
                  <th style={{textAlign:'center',padding:'1em'}}>High Credit</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Credit Limit</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Cash Limit</th>
                   <th style={{textAlign:'center',padding:'1em'}}>Settelement</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Suites</th>
                  <th style={{textAlign:'center',padding:'1em'}}>Remarks</th>
                </thead>
                <tbody >
                
                    {  experianReport?.accounts?.map((item)=>{
                return(
                  <tr >
                    <td title={item.subscriberName}style={{textAlign:'center',backgroundColor:item?.dateClosed?"#898989":"#ECFDF3",color:item?.dateClosed?"white":"#12B76A"}}>{item.accountType}</td>
                    <td style={{textAlign:'center'}}>{item?.ownershipType}</td>
                    <td style={{textAlign:'center'}}>{item?.disbursedDate?moment(item?.disbursedDate).format('DD MMM YYYY'):"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.dateClosed?moment(item?.dateClosed).format('DD MMM YYYY'):"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.collateralType?item?.collateralType:"NA"}</td>
                    <td style={{textAlign:'center'}}>{item?.sanctionedAmount}</td>
                    <td style={{textAlign:'center'}}>{item?.currentBalance}</td>
                    <td style={{textAlign:'center'}}>{item?.overdue?item?.overdue:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.emi?item?.emi:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.paymentFrequency?item?.paymentFrequency:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.repaymentTenure?item?.repaymentTenure:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.rateOfInterest?item?.rateOfInterest:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.actualPayment?item?.actualPayment:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.highCredit?item?.highCredit:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.creditLimit?item?.creditLimit:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.cashLimit?item?.cashLimit:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.settlementAmount?item?.settlementAmount:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.suitFiledOrWilfulDefault?item?.suitFiledOrWilfulDefault:"--"}</td>
                    <td style={{textAlign:'center'}}>{item?.creditFacilityStatus?item?.creditFacilityStatus:"--"}</td>
                    
                  </tr>
                )
                }
                )
              }
                
                </tbody>
              </Table>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion style={{marginTop:'1em',marginBottom:'1em'}}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography><img style={{marginRight:'1em'}}src={monthwise} alt=""/><span style={{fontSize:'18px',fontWeight:'bold',fontFamily:'Outfit'}}>Month-Wise EMI History ( last 3 years)</span></Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography >
              <div className="wrapper">
                  <div className="barWrapper">
                    <Bar className="bar" redraw={true} options={optionsBar} data={dataBar} />
                  </div>
              </div>
            
            </Typography>
          </AccordionDetails>
        </Accordion>
        </> /* CLOSING THE FRAGMENT HERE */))}
          </>
        )
      }
      {/* New Modal for re-entering mobile number */}
      <Modal isOpen={reInvokeModal} toggle={toggleReInvokeModal} centered>
        <ModalHeader toggle={toggleReInvokeModal}>Re-enter Mobile Number</ModalHeader>
        <ModalBody>
          <Label for="newMobile">Mobile Number</Label>
          <Input
            type="text"
            id="newMobile"
            value={newMobileNumber}
            onChange={(e) => setNewMobileNumber(e.target.value)}
            placeholder="Enter 10 digit mobile number"
            maxLength="10"
            pattern="\d*" // Suggests numeric input for mobile
            inputMode="numeric" // Helps with mobile keyboard on touch devices
            disabled={isLoading} // Disable input while loading
          />
          <div style={{ marginTop: '1.5em', textAlign: 'right' }}>
            <Button color="secondary" onClick={toggleReInvokeModal} disabled={isLoading} style={{ marginRight: '10px' }}>
              Cancel
            </Button>
            <Button 
               style={{fontSize: '16px',backgroundColor:"#D32028",border:'none' }}
              onClick={handleRetrySubmit} 
              disabled={isLoading || !newMobileNumber || newMobileNumber.length !== 10 || !/^\d{10}$/.test(newMobileNumber)}
            >
              {isLoading ? 'Submitting...' : 'Submit'} {/* Show loader text */}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}